<template>
  <div class="view-feed">
    <header class="page-header">
      <div class="container py-5 text-light">
        <h1 class="text-center mb-4">Conteúdo</h1>
        <div class="row">
          <div class="col-lg-8 mx-auto">
            <form
              class="form-group d-flex align-items-center"
              @submit.prevent="submit"
            >
              <button class="bg-transparent border-0 p-0" type="submit">
                <i class="fas fa-search text-secondary"></i>
              </button>
              <input
                ref="input"
                class="form-control"
                placeholder="Buscar"
                v-model="text"
                type="text"
              />
            </form>
          </div>
        </div>
      </div>
    </header>

    <div v-if="searchResults" class="pb-5">
      <search-resources :text="text" />

      <div class="container">
        <div class="row">
          <div
            class="col-lg-3 col-md-4 col-6 pb-3"
            v-for="(lesson, index) in searchResults"
            :key="index"
          >
            <lesson-slide :lesson="lesson" />
          </div>
        </div>

        <div
          v-if="!searchResults.length"
          class="text-center text-secondary py-5"
        >
          Não foram encontrados resultados para: {{ text }}
        </div>
      </div>
    </div>

    <template v-else>
      <div v-for="(month, index) in feed" :key="index">
        <section v-if="index > 0" class="bg-dark py-2"></section>

        <month-lessons class="py-5" :month="month" :number="month.index" />
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import get from "lodash/get";
import MonthLessons from "@/components/feed/MonthLessons";
import SearchResources from "@/components/feed/SearchResources";
import LessonSlide from "@/components/home/LessonSlide";

export default {
  components: { MonthLessons, SearchResources, LessonSlide },
  data() {
    return {
      text: this.$route.query.search
    };
  },
  computed: {
    ...mapState("courses", ["feed"]),
    lastMonth() {
      return get(this.feed, "[0]", { lessons: [] });
    },
    lastLesson() {
      return this.lastMonth.lessons.find(ls => !ls.is_month);
    },
    searchResults() {
      if (this.text) {
        return this.feed
          .reduce((prev, cur) => [...prev, ...cur.lessons], [])
          .filter(l =>
            `${l.full_title} ${l.description}`
              .toLowerCase()
              .includes(this.text.toLowerCase())
          );
      }

      return null;
    }
  }
};
</script>
<style lang="scss" scoped>
.view-feed {
  .form-group {
    position: relative;
    i {
      position: absolute;
      top: 50%;
      left: 2%;
      transform: translate(-5%, -50%);
    }
    .form-control {
      border: 1px solid #bbbbbb;
      background-color: transparent;
      border-radius: 30px;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 28px;
      color: #fff;
      padding-left: 3rem;
    }
  }
}
</style>
